import { render } from "./Agents.vue?vue&type=template&id=1985e4c6&scoped=true"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"

import "./Agents.vue?vue&type=style&index=0&id=1985e4c6&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1985e4c6"]])

export default __exports__